import axios from '@/plugins/Axios'
// import Mapper from './Mapper'

function Requests () {
  async function fetchBuyerAccount() {
    try {
      const { data } = await axios.get('/my-account')
      return data.buyer
    } catch (error) {
      console.log(error)
    }
  }

  
  async function updateBuyerAccount(formData) {
    try {
      const { data } = await axios.post('/my-account', formData)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function contactUs(formData) {
    try {
      const { data } = await axios.post('/contact-us', formData)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  return {
   fetchBuyerAccount,
   updateBuyerAccount,
   contactUs
  }
}

export default Requests()